import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FounderCard from '@/components/Cards/FounderCard';
import { useGetActiveFounders } from '@/query/queries/brand/useGetActiveFounders';

const FoundersActive = () => {
  const { t } = useTranslation('brands');
  const { data: founders } = useGetActiveFounders();

  const hasFounders = !!(founders && founders.pages[0].total_count);

  if (!hasFounders) {
    return null;
  }

  return (
    <div className="founders-active">
      <h2 className="f-26 f-500">
        {t('founders.active.title')}{' '}
        {hasFounders && `(${founders.pages[0].total_count})`}
      </h2>
      <p className={classnames('founders-active__desc', 'f-16 f-400')}>
        {t('founders.active.description')}
      </p>
      {hasFounders ? (
        <div className="founders-active__list">
          {founders.pages.map(page =>
            page.list.map(founder => (
              <FounderCard key={founder.id} founder={founder} active hideFR />
            )),
          )}
        </div>
      ) : (
        <div className="founders-active__empty">
          <span className="founders-active__empty-title f-16 f-400">
            {t('founders.active.no_founders')}
          </span>
        </div>
      )}
    </div>
  );
};

export default FoundersActive;
